import angular from "angular";

/**
 * Service to handle "locked" state of something.
 * If locked, promise is created;
 * If unlicked, promise is resolved;
 * Usage: SaveGuard.check().then(()=> // do code if state unlocked );
 */
export default angular.module('cms.save.guard', []).factory('SaveGuard', function() {

    let promise = new Promise(resolve => resolve());
    let _resolveFn = null;

    return {
        check: () => promise,
        lock: () => promise = new Promise(resolve => _resolveFn = resolve),
        unlock: () => _resolveFn()
    };
}).name;


// WEBPACK FOOTER //
// ./src/cmsCore/SaveGuard/SaveGuard.js